import posthogClient from "posthog-js";

import { getEnv } from "@/hooks/useEnv";

import type { UserProfile } from "@/supabase.types";

(() => {
  if (getEnv("VITE_POSTHOG_TOKEN") && getEnv("VITE_POSTHOG_API_HOST")) {
    posthogClient.init(getEnv("VITE_POSTHOG_TOKEN") ?? "", {
      api_host: getEnv("VITE_POSTHOG_API_HOST") ?? "",
      ui_host: "https://eu.posthog.com",
      secure_cookie: true, // transport only over https
      capture_pageview: false, // we manually capture pageviews via <AnalyticsRouterTracker />
      session_recording: {
        maskAllInputs: false, // de-mask all inputs in Posthog records
        maskInputOptions: {
          password: true, // ... except for password inputs!
        },
      },
    });
  }
})();

export const posthog = posthogClient;

export const setPosthogUser = (profile?: UserProfile | null) => {
  if (profile && !posthog._isIdentified()) {
    posthog.identify(profile.id, {
      ...profile,
    });
    if (getEnv("VITE_RELEASE_TAG")) {
      posthog.register({ release: getEnv("VITE_RELEASE_TAG") });
    }
  }
};
export const clearPosthogUser = () => posthog.reset();

export const trackPosthogEvent = (action: string, entity: string, properties?: Record<string, unknown>) => {
  posthog.capture(`${action} ${entity}`, {
    action,
    entity,
    ...properties,
  });
};
